import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogContent,
} from "@mui/material";
import QRCode from "qrcode.react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { isInApp } from '../utils/environment';
const InviteQRCode = () => {
  const [copied, setCopied] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const location = useLocation();
  const inviteInfo = location?.state?.inviteInfo || {};
  const inviteLink = inviteInfo?.inviteCode || '';
  const navigate = useNavigate();

  const handleCopy = async () => {
    if (isInApp()) {
      if (window.flutterApp) {
        const copyData = {
          type: 'Copy',
          text: inviteLink
        };
        window.flutterApp.postMessage(JSON.stringify(copyData));
      }
      return;
    }
    await navigator.clipboard.writeText(inviteLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        minHeight: "100vh",
        maxWidth: "430px",
        margin: "0 auto",
      }}
    >
      {/* Header */}
      {
        !isInApp() && (
          <Box
          sx={{
            height: "48px",
            display: "flex",
            alignItems: "center",
            px: "16px",
            borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
          }}
        >
          <IconButton
            edge="start"
            sx={{
              color: "#000",
              p: 0,
              mr: "8px",
            }}
            onClick={() => navigate(-1)}
          >
            <ArrowBackIcon sx={{ fontSize: 24 }} />
          </IconButton>
          <Typography
            sx={{
              flex: 1,
              textAlign: "center",
              fontSize: "18px",
              fontWeight: 600,
              mr: "32px",
              color: "#000",
            }}
          >
            Invite QR Code
          </Typography>
        </Box>
        )
      }

      <Container sx={{ px: "16px" }}>
        {/* Title Section */}
        <Box sx={{ mt: "32px", mb: "24px", textAlign: "center" }}>
          <Typography
            sx={{
              fontSize: "32px",
              fontWeight: 700,
              lineHeight: 1.2,
              mb: "8px",
              color: "#000",
              letterSpacing: "-0.02em",
            }}
          >
            Earn Money By Refer
          </Typography>
          <Typography
            sx={{
              fontSize: "17px",
              color: "rgba(0, 0, 0, 0.6)",
              mb: "4px",
              fontWeight: 400,
            }}
          >
            Love, Peace of Mind 
          </Typography>
          <Typography
            sx={{
              fontSize: "17px",
              color: "rgba(0, 0, 0, 0.6)",
              fontWeight: 400,
            }}
          >
            User Name invites you to join
          </Typography>
        </Box>

        {/* Buttons */}
        <Box
          sx={{
            display: "flex",
            gap: "12px",
            mb: "24px",
            px: "4px",
          }}
        >
          <Button
            fullWidth
            onClick={handleCopy}
            sx={{
              height: "48px",
              bgcolor: "#fff",
              border: "1px solid rgba(0, 0, 0, 0.12)",
              borderRadius: "8px",
              color: "#000",
              fontSize: "17px",
              fontWeight: 500,
              textTransform: "none",
              "&:hover": {
                bgcolor: "#fff",
                border: "1px solid rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            {copied ? "Copied" : "Copy"}
          </Button>
          <Button
            fullWidth
            onClick={handleOpenDialog}
            sx={{
              height: "48px",
              bgcolor: "#007AFF",
              borderRadius: "8px",
              color: "#fff",
              fontSize: "17px",
              fontWeight: 500,
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                bgcolor: "#0066CC",
                boxShadow: "none",
              },
            }}
          >
            Save
          </Button>
        </Box>

        {/* QR Code Card */}
        <Box
          sx={{
            position: "relative",
            width: "100%",
            mb: "24px",
          }}
        >
          {/* 顶部蓝色渐变条 */}
          <Box
            sx={{
              position: "absolute",
              top: -3,
              left: "50%",
              transform: "translateX(-50%)",
              width: "90%",
              height: "8px",
              background: "linear-gradient(90deg, #579AFF 0%, #2979FF 100%)",
              borderRadius: "8px",
              zIndex: 2,
              boxShadow: "0px 2px 8px rgba(0, 122, 255, 0.15)",
            }}
          />

          <Box
            sx={{
              position: "relative",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "60px",
                background: "linear-gradient(180deg, #E3EDFF 0%, #F5F9FF 100%)",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
                zIndex: 0,
              },
            }}
          >
            <Box
              sx={{
                bgcolor: "#fff",
                borderRadius: "8px",
                boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                p: "32px",
                position: "relative",
                zIndex: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  "& canvas": {
                    borderRadius: "8px",
                    width: "100% !important",
                    height: "auto !important",
                    maxWidth: "280px",
                  },
                }}
              >
                <QRCode
                  value={inviteLink}
                  size={280}
                  level="H"
                  includeMargin={true}
                  imageSettings={{
                    src: "/logo.png",
                    height: 24,
                    width: 24,
                    excavate: true,
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "32px", // 调整尺寸
                    height: "32px", // 调整尺寸
                    bgcolor: "#007AFF", // 调整颜色
                    borderRadius: "8px", // 调整圆角
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontSize: "18px", // 调整字号
                    fontWeight: 500,
                  }}
                >
                  H
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Bottom Text */}
        <Typography
          sx={{
            textAlign: "center",
            fontSize: "15px",
            color: "rgba(0, 0, 0, 0.6)",
            fontWeight: 400,
            mb: "32px",
          }}
        >
          Please search "uTaxes" in the app store to download the app.
        </Typography>
      </Container>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        PaperProps={{
          sx: {
            bgcolor: "#fff",
            borderRadius: "px",
            m: 2,
            mt: "20px",
            height: "90%",
          },
        }}
      >
        <DialogContent sx={{ p: "20px 16px" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* Logo */}
            <img
              src={require("../assets/images/none-text-logo.png")}
              alt="uTaxes"
              style={{
                width: "48px", // 调整为设计稿尺寸
                height: "48px", // 调整为设计稿尺寸
                marginBottom: "8px", // 调整间距
              }}
            />
            <Typography
              sx={{
                fontSize: "24px", // 调整字号
                lineHeight: "28px", // 添加行高
                fontWeight: 600,
                color: "#000",
                mb: "4px", // 调整间距
              }}
            >
              uTaxes
            </Typography>
            <Typography
              sx={{
                fontSize: "17px",
                lineHeight: "22px", // 添加行高
                color: "rgba(0, 0, 0, 0.6)",
                mb: "16px", // 调整间距
              }}
            >
              Love, Peace of Mind 
            </Typography>
            <Typography
              sx={{
                fontSize: "15px",
                lineHeight: "20px", // 添加行高
                color: "rgba(0, 0, 0, 0.6)",
                mb: "24px", // 调整间距
              }}
            >
              User Name invites you to join
            </Typography>

            {/* QR Code Container */}
            <Box
              sx={{
                width: "100%",
                height: "335px", // 调整为设计稿高度
                background:
                  "linear-gradient(180deg, rgba(99, 167, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%)", // 调整渐变
                borderRadius: "8px", // 调整圆角
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: "24px", // 调整间距
              }}
            >
              <Box
                sx={{
                  width: "240px", // 调整为设计稿尺寸
                  height: "240px", // 调整为设计稿尺寸
                  position: "relative",
                  bgcolor: "#fff",
                  borderRadius: "8px", // 调整圆角
                  padding: "20px", // 调整内边距
                  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)", // 调整阴影
                }}
              >
                <QRCode
                  value={inviteLink}
                  size={240}
                  level="H"
                  includeMargin={true}
                  imageSettings={{
                    src: "/logo.png",
                    height: 24,
                    width: 24,
                    excavate: true,
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "32px", // 调整尺寸
                    height: "32px", // 调整尺寸
                    bgcolor: "#007AFF", // 调整颜色
                    borderRadius: "8px", // 调整圆角
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    fontSize: "18px", // 调整字号
                    fontWeight: 500,
                  }}
                >
                  H
                </Box>
              </Box>
            </Box>

            {/* Bottom Text */}
            <Typography
              sx={{
                fontSize: "13px",
                lineHeight: "18px", // 添加行高
                color: "#000",
                textAlign: "center",
                fontWeight: 400,
              }}
            >
              Please search "uTaxes" in the app store to download the app.
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default InviteQRCode;
